import { Box, Button, Typography, Paper } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { Link as RouterLink } from "react-router-dom";

export default function PrivacyPolicyPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        py: 4,
        px: 2,
        backgroundColor: "#f5f5f5",
      }}
    >
      <Helmet>
        <title>Privacy Policy</title>
      </Helmet>

      <Paper
        elevation={3}
        sx={{
          maxWidth: 600,
          width: "100%",
          p: 4,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Typography variant="h4" component="h1" gutterBottom fontWeight="700" textAlign="center">
          Privacy Policy
        </Typography>

        <Typography variant="body2" color="text.secondary" textAlign="center">
          Last updated: July 27, 2026
        </Typography>

        <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography variant="h6" component="h2" fontWeight="600">
            1. Information We Collect
          </Typography>
          <Typography variant="body2">
            We collect information you provide directly to us when creating or updating your account,
            such as username, email address, and profile details. If you use our contract management services,
            we also process information contained within the contracts you upload or create.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="600">
            2. How We Use Your Information
          </Typography>
          <Typography variant="body2">
            We use the information we collect to provide, maintain, and improve our services, including to:
            facilitate user authentication, manage contract workflows, send notifications, and prevent
            unauthorized access to accounts and sensitive data.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="600">
            3. Data Security
          </Typography>
          <Typography variant="body2">
            We implement appropriate technical and organizational measures to protect the security of your
            personal data and contract files against unauthorized access, alteration, disclosure, or destruction.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="600">
            4. Sharing of Information
          </Typography>
          <Typography variant="body2">
            We do not share your personal information or contract data with third parties except as required by
            law or with your explicit consent.
          </Typography>

          <Typography variant="h6" component="h2" fontWeight="600">
            5. Contact Us
          </Typography>
          <Typography variant="body2">
            If you have any questions or concerns about this Privacy Policy, please contact our support team.
          </Typography>
        </Box>

        <Button
          variant="contained"
          color="primary"
          component={RouterLink}
          to="/"
          sx={{ mt: 4, alignSelf: "center" }}
        >
          Back to Sign In
        </Button>
      </Paper>
    </Box>
  );
}
